export default __webpack_public_path__ + "static/yeepy-back-0b2157890bcb2f1bd78fd1efe81297dc.webp";